exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._toolbar{background-color:#dc2814!important;color:#fff}._toolbar .progress-linear{position:absolute;left:0;right:0;bottom:0;margin:0}._toolbar .toolbar__logo{flex-grow:100}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/toolbar/toolbar.styl
// module id = 423
// module chunks = 0